module.exports = __webpack_public_path__ + "static/media/nft1.46d39591.jpg";